import * as React from "react";
import { Button, Col, FormGroup, Form, FormControl, Panel, Alert } from "react-bootstrap"

import { side } from "../Component/components"
import { ModellComponent } from "../Component/ModellComponent"
import { navigateToRoute } from "../Component/navigation"
import { alleHandlingerEkstra } from "../Component/Handlinger";
import { showSetPasswordPopup } from "../Login/SetPassword";
import { ILoaderProps, IModelLaster, IRouteComponent } from "../domene"
import { poliseVerdiFormattert, errors } from "../Component/felt";
import { sokeForm } from "../Component/sok";
import { appContext } from "../App/appContext"

import { Okonomi } from "./Okonomi";

import Models = Gf.Web.Models;

export class Start extends ModellComponent<Models.StartModell> {

    constructor(props: ILoaderProps) { super(props); }

    getModelPath() {
        const q = appContext.getQueryUrlParam();
        return `/Start/Start${q ? `?q=${q}`: ""}`;
    }

    protected renderWithModel(model: Models.StartModell | undefined) {
        const q = appContext.getQueryUrlParam();
        return side(`Velkommen${appContext.effektivAktørNavn ? `, ${appContext.effektivAktørNavn}` : ""}`,
            <div>
                { knapper(model, this) }
                { errors(this) }
                {brukerTilpassetVisning(model, this.laster, q) }</div>);
    }

    protected afterLoading() {
        const username = this.props.params["username"];
        const code = this.props.params["code"];
        if (username && code) {
            showSetPasswordPopup({
                Username: username,
                Code: code,
                Password: "",
                RepeatPassword: "",
                ClickedEmailLink: true,
                SetName: false,
                Name: ""
            });
        }
    }
}

function brukerTilpassetVisning(model: Models.StartModell | undefined, laster: IModelLaster, q?: string): (JSX.Element | null)[] {
    const eksternBruker = appContext.harRelasjon(Gf.Dom.Type.AktørrelasjonType.EksternBruker);

    if(model === undefined) {
        return [];
    }
    if(appContext.anonym()) {
         return [ anonym() ];
    }
    if (eksternBruker) {
        return [poliser(model, laster, true, q)];
    }
    const visØkonomi = appContext.harRelasjon(
        Gf.Dom.Type.AktørrelasjonType.Administrator,
        Gf.Dom.Type.AktørrelasjonType.Regnskapsmedarbeider);
    return [
        poliser(model, laster, false, q),
        visØkonomi ? okonomi(model, laster) : null
    ];
}

const anonym = () => <div key="anonym">Logg inn med valget øverst til høyre på siden.</div>;

const visPolise = (poliseId: number) => navigateToRoute(`/Polise/${poliseId}`);

function poliser(model: Models.StartModell, laster: IModelLaster, eksternBruker: boolean, q?: string) : JSX.Element | null {
    return model.Poliser.Rader.length === 0 && !q
        ? null
        : <div>
              <h3>Søkeresultater</h3>{
            model.Poliser.Rader.length > 0
                ? model.Poliser.Rader.map(r => {
                    const harKjennetegn = poliseVerdiFormattert(model.Poliser, r, Models.PoliseFeltType.Kjennetegn, laster)
                    return <Panel className="polisePanel" key={r.EntitetId} onClick={() => eksternBruker ? () => {} : visPolise(r.EntitetId)} header={`Polise ${poliseVerdiFormattert(model.Poliser, r, Models.PoliseFeltType.PoliseNr, laster)}`}>
                        <table><tbody>
                            <tr>
                                <td className="startFelt">Navn:</td><td className="startVerdi">{poliseVerdiFormattert(model.Poliser, r, Models.PoliseFeltType.ForsikringstakerNavn, laster)}</td>
                                <td className="startFelt">{harKjennetegn ? "Kjennetegn" : "Chassisnummer"}:</td><td className="startVerdi">
                                {harKjennetegn
                                    ? poliseVerdiFormattert(model.Poliser, r, Models.PoliseFeltType.Kjennetegn, laster)
                                    : poliseVerdiFormattert(model.Poliser, r, Models.PoliseFeltType.Chassisnummer, laster)
                                }</td>
                                <td className="startFelt">Utstedt:</td><td className="startVerdi hoyre">{poliseVerdiFormattert(model.Poliser, r, Models.PoliseFeltType.UtstedtDato, laster) }</td>
                            </tr>
                            <tr>
                                <td className="startFelt">Kjøretøyklasse:</td><td className="startVerdi">{poliseVerdiFormattert(model.Poliser, r, Models.PoliseFeltType.Kjøretøyklasse, laster)}</td>
                                <td className="startFelt">Merke:</td><td className="startVerdi">{poliseVerdiFormattert(model.Poliser, r, Models.PoliseFeltType.Merke, laster)}</td>
                                <td className="startFelt">Varer til:</td><td className="startVerdi hoyre">{poliseVerdiFormattert(model.Poliser, r, Models.PoliseFeltType.VarighetTilDato, laster) }</td>
                            </tr>
                            </tbody></table>
                    </Panel>})
              : <Alert bsStyle="warning">Ingen poliser samsvarte med dette søket</Alert>}</div>;
}

function knapper(
    model: Models.StartModell | undefined,
    handler: IRouteComponent,
    parameterHenter?: (handlingType: Gf.Web.Models.HandlingType) => string | undefined): JSX.Element | null {

    if(model === undefined) {
        return null;
    }
    const sok = !appContext.anonym();
    const okonomi = appContext.harRelasjon(Gf.Dom.Type.AktørrelasjonType.Regnskapsmedarbeider);
    return sok
            ? sokeForm(model.Handlinger, handler, "Polisenummer, registreringsnummer eller navn", parameterHenter)
            : okonomi
                ? alleHandlingerEkstra(model.Handlinger, handler, [], parameterHenter)
                : alleHandlingerEkstra(model.Handlinger, handler);
}

const okonomi = (model: Models.StartModell, laster: IModelLaster) =>
    <Okonomi key="okonomi" model={model} laster={laster} />;



// WEBPACK FOOTER //
// ./Scripts/React/Start/Start.tsx